// Close main-menu
function menu() {
    // Mobile to tablet portrait Only JS
    if (matchMedia('(max-width: 767px)').matches) {

        // Open main-menu
        $('.button__menu-open').on(
          'click',
          function(e) {
              $(this).addClass('open');
              $('html').addClass('menu-mobile--active');
          }
        );
        //
        // // Close main-menu
        // $('.button__menu-close').on(
        //     'click', function (e) {
        //         $('.button__menu-open').removeClass('open');
        //         $('html').removeClass('menu-mobile--active');
        //     }
        // );
    }

    //Tablet Landscape to Desktop only JS
    if (matchMedia('(min-width: 768px) and (orientation:landscape)').matches) {
        $('.button__menu-open').removeClass('open');
        $('html').removeClass('menu-mobile--active');
    }

    $(window).resize(
      function() {

          $('.button__menu-open').removeClass('open');
          $('html').removeClass('menu-mobile--active');

          // Open main-menu
          $('.button__menu-open').on(
            'click',
            function(e) {
                $(this).addClass('open');
                $('html').addClass('menu-mobile--active');
            }
          );

          // Close main-menu
          $('.button__menu-close').on(
            'click',
            function(e) {
                $('.button__menu-open').removeClass('open');
                $('html').removeClass('menu-mobile--active');
            }
          );
      }
    );

    var mySideNav = $('#mySidenav'),
      containerBody = $('#container-body');

    $('.modif-action').on(
      'click',
      function(e) {
          e.preventDefault();
          containerBody.addClass('sidenav__edit--is-open');
      }
    );

    $('.sidenav__edit button.btn-close__red').on(
      'click',
      function(e) {
          e.preventDefault();
          containerBody.removeClass('sidenav__edit--is-open');
      }
    );

    $('.btn-slidenav').off().on(
      'click',
      function(e) {
          e.preventDefault();
          $(this).toggleClass('active');
          mySideNav.toggleClass('active');
          $(".header__content").toggleClass("active");
          if (!mySideNav.hasClass('active')) {
              containerBody.removeClass('sidenav__edit--is-open');
          }
      }
    );

    // SimpleScrollbar.initAll();

    // var scrollTo = function(anchor) {
    //   var container = $('.contenu_onglet.current');
    //   var topValue = container.scrollTop() + $(anchor).offset().top;
    //   container.animate({
    //     scrollTop: topValue - 160
    //   }, 'slow');
    // };

    // $('.contenu_onglet .zone-icons').find('span:not(".click-navs") a[href^="#"]').on(
    //   'click',
    //   function(e) {
    //     e.preventDefault();
    //     var anchor = $(this).attr('href');
    //     scrollTo(anchor);
    //   }
    // );
    //
    // <!-- Colonne de droite : ScrollTo via icons prev/next -->
    // $('.click-navs a').on(
    //   'click',
    //   function(e) {
    //     e.preventDefault();
    //     var currentBlock = $('.contenu_onglet.current .block-slide-right.current');
    //     var anchor = ($(this).hasClass('prev')) ? currentBlock.prev() : currentBlock.next();
    //     if (anchor.get(0) === undefined) {
    //       return false;
    //     }
    //     scrollTo(anchor);
    //   }
    // );


    }

//
// <!-- Javascript pour le dropdown des items de la colonne de gauche
//     $("#left-menu a.menu-dropdown").click(function(e){
//         var target = $(e.target);
//         if (!target.closest('#left-menu a.menu-dropdown').hasClass('active')) {
//             var dropdown = $('#left-menu a.menu-dropdown.active');
//             $("ul.dropdown-menu").slideUp();
//             dropdown.removeClass('active');
//         }
//         $(this).parent().find("ul.dropdown-menu").slideToggle();
//         $(this).toggleClass("active");
//     });
//     $(window).on(
//         'click', function (e) {
//             var target = $(e.target);
//             if (!target.closest('#left-menu a.menu-dropdown').hasClass('active')) {
//                 var dropdown = $('#left-menu a.menu-dropdown.active');
//                 $("ul.dropdown-menu").slideUp();
//                 dropdown.removeClass('active');
//             }
//             if (!target.hasClass('search__list active')) {
//                 $('.search__list').removeClass('active');
//             }
//         }
//     );
//
//      -->
